import { Slide, Snackbar, SnackbarContent } from '@mui/material';
import { styled } from '@mui/material/styles';
import { TransitionProps } from '@mui/material/transitions';
import { CloseRounded, DeleteRounded } from '@mui/icons-material';
import { ReactElement, SyntheticEvent } from 'react';
import { useSelector } from 'react-redux';

// Components.
import { Button } from 'components';

// Core.
import { ToastLocationEnum, ToastType } from 'core/enums';
import { useAppDispatch } from 'core';

// Styles.
import './Toast.module.scss';

// Store.
import { eatToast } from 'store/toast/actions';
import { isToastOpenSelector, toastOptionsSelector } from 'store/toast/selectors';

let isToastTop = false;

function SlideTransition(props: TransitionProps & { children: ReactElement }) {
  return <Slide {...props} direction={isToastTop ? 'down' : 'up'} />;
}

const StyledSnackBarContent = styled(SnackbarContent)({
  toastmessage: {
    '& > div': {
      width: '100%',
    },
    borderRadius: 0,
    width: '100%',
  },
  borderRadius: 0,
  width: '100%',
  justifyContent: 'space-around',
  fontSize: 'inherit',
});

export const Toast = (): ReactElement => {
  const dispatch = useAppDispatch();
  const isToastOpen = useSelector(isToastOpenSelector);
  const toastOptions = useSelector(toastOptionsSelector);

  if (!toastOptions) return null;

  const { autoHideDuration, dismissable, icon, location, message, toastType } = toastOptions;

  isToastTop = location === ToastLocationEnum.Top || false;

  const handleClose = (_: SyntheticEvent | MouseEvent, reason?: string): void => {
    if (reason === 'clickaway') {
      dispatch(eatToast());
    }

    dispatch(eatToast());
  };

  return (
    <>
      <Snackbar
        anchorOrigin={{
          horizontal: 'center',
          vertical: isToastTop ? 'top' : 'bottom',
        }}
        sx={{ width: '100%' }}
        onClose={handleClose}
        open={isToastOpen}
        autoHideDuration={autoHideDuration}
        transitionDuration={{ exit: 300 }}
        slots={{
          transition: SlideTransition,
        }}
      >
        <StyledSnackBarContent
          sx={{
            backgroundColor:
              toastType === ToastType.TOAST_ALERT
                ? '#bd2e2a'
                : toastType === ToastType.TOAST_WARNING
                  ? '#e2a641'
                  : toastType === ToastType.TOAST_SUCCESS
                    ? '#2a835a'
                    : '#00838f',
          }}
          message={
            <div className={'toast-content'}>
              {icon && <DeleteRounded className="icon" />}
              {message}
              {dismissable && (
                <Button className="close" onClick={handleClose}>
                  <CloseRounded />
                </Button>
              )}
            </div>
          }
        />
      </Snackbar>
    </>
  );
};
